import { Outlet } from '@tanstack/react-router';

/**
 * Frame of the administration. Its pages are in the navigation under "Verwaltung", in the sidebar
 * and in the menu on the phone; the overview page lists them as well, and each page links back by
 * breadcrumb.
 */
export function AdminLayout() {
  return <Outlet />;
}
